import { render, staticRenderFns } from "./ContiguityListSimple.vue?vue&type=template&id=2e4bc330&scoped=true&"
import script from "./ContiguityListSimple.vue?vue&type=script&lang=js&"
export * from "./ContiguityListSimple.vue?vue&type=script&lang=js&"
import style0 from "./ContiguityListSimple.vue?vue&type=style&index=0&id=2e4bc330&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4bc330",
  null
  
)

export default component.exports